<div [ngStyle]="{'height': parentHeight}"
     class="data-table"
     (mouseenter)="onMouseEnter()"
     (mouseleave)="onMouseLeave()"
     appHorizontalScroll>
  <table style="width: 100%;"
         mat-table
         [dataSource]="props?.dataSource"
         matSort
         multiTemplateDataRows
         class="mat-elevation-z8 custom-table-striped">

    <ng-container [matColumnDef]="tableData"
                  *ngFor="let tableData of objectKeys(columnHeader)">
      <th (click)="sortColumn(tableData)"
          class="cp"
          [ngStyle]="{'border-top-right-radius': (columnHeader[tableData]==lastColumn)
                          && (roundedTable)? '10px' : '0',
           'border-top-left-radius': (columnHeader[tableData]==firstColumn)
             && (roundedTable)? '10px' : '0' ,
             'width':(columnHeader[tableData]=='Action')&&(lastColumn=='')?'100px':'0px' }"
          mat-header-cell
          mat-sort-header
          mat-sticky-header
          [disabled]="!sortheaders?.includes(tableData)"
          *matHeaderCellDef>
        <span>{{columnHeader[tableData]}}</span>
        <mat-cell *ngIf="columnHeader[tableData] == '' && hasHeaderCheckBox"
                  style="padding:0px !important">
          <mat-checkbox (change)="onHeaderCheckBox($event.checked)"
                        [(ngModel)]="headerCheckBoxValue"
                        class="example-margin"></mat-checkbox>
        </mat-cell>

      </th>
      <ng-container *matCellDef="let element; let index">
        {{seeElement(tableData, element)}}

        <td (click)="clickView(element,tableData)"
            [ngClass]="{'cp': isViewClick}"
            [ngStyle]="{'background': tableData == 'breakIntoDisplay' || tableData == 'breakOuttoDisplay' ? 'rgb(222, 244, 255)': inherit}">

          <mat-cell [ngStyle]="{'width': getCellWidth(tableData)}"
                    *ngIf="!showImage && !showActions && !hasDivs &&
                    !expandPanel && !hasCustomData && !hasimageDialog && !hasPreCircle && !hasCheckBox && tableData != 'actionStatusColumn' && tableData != 'expand'">

            <ng-container *ngIf="!props.inputData.hasViewMore">
              <span *ngIf="!hasTitle">
                <span *ngIf="tableData != 'discrepancy' && tableData != 'note'">
                  {{ element[tableData]?.name || element[tableData]}}
                </span>

                <span *ngIf="element.sessionTime && tableData == 'session'"
                      style="font-size: 12px;"><br>{{element.sessionTime}}
                </span>
                <span *ngIf="tableData == 'discrepancy' && element.discrepancy == 'Discarded'">
                  <span style="position: relative;"
                        matTooltipClass="custom-tooltip"
                        [matTooltip]="element.discrepancyNote">
                    {{element[tableData]}}
                  </span>
                </span>
                <span *ngIf="tableData == 'discrepancy' && element.discrepancy != 'Discarded'">
                  {{element[tableData]}}
                </span>

                <span *ngIf="tableData == 'note' && element.longNote">
                  <span style="position: relative;"
                        matTooltipClass="custom-tooltip"
                        [matTooltip]="element.showNote">
                    {{element[tableData]}}
                  </span>
                </span>
                <span *ngIf="tableData == 'note' && !element.longNote">
                  {{element[tableData]}}
                </span>
              </span>
              <span *ngIf="hasTitle"
                    [title]="element[tableData]?.name || element[tableData]">{{ element[tableData]?.name || element[tableData]}}</span>
            </ng-container>

            <ng-container *ngIf="props.inputData.hasViewMore">
              <!-- <span class="ellipsis" [ngStyle]="{'text-overflow' : ellipse && !element.viewMore ? 'ellipsis': 'unset', 'white-space': ellipse && !element.viewMore ? 'nowrap': 'unset'}" *ngIf ="!hasTitle" >{{ getSmall(element[tableData]?.name) || getSmall(element[tableData])}} <span class="viewMore" *ngIf="props.inputData.viewMoreColumn == tableData && element[tableData]?.length > 30" (click)="toggle(element)"> {{ ellipse ? ' ...View More' : 'View Less' }}  </span></span> -->
              <span class="ellipsis"
                    *ngIf="!hasTitle">{{ getTrimmedText(element[tableData]?.name) || getTrimmedText(element[tableData])}}
                <span class="viewMore"
                      *ngIf="props.inputData.viewMoreColumn == tableData && element[tableData]?.length > 30"
                      (click)="openViewMore(element[tableData])"> {{ ellipse ? ' ...View More' : 'View Less' }}
                </span></span>
            </ng-container>

          </mat-cell>
          <mat-cell *ngIf="hasCheckBox"
                    style="padding:0px !important">
            <mat-checkbox (change)="onCheckBox(element, $event.checked)"
                          [checked]="element[tableData]"
                          class="example-margin"></mat-checkbox>
          </mat-cell>
          <mat-cell *ngIf="tableData == 'actionStatusColumn'"
                    style="padding:0px !important">
            <!-- <button style="border: 1px solid #D5D5D5; margin: 0 10px;"
                    (click)="columnClick(element)"
                    mat-button>{{element[tableData]}}</button> -->
            <mat-slide-toggle [(ngModel)]="element.status"
                              (click)="columnClick(element)"></mat-slide-toggle>
          </mat-cell>
          <mat-cell *ngIf="showImage && !hasimageDialog ">
            <img style="height: 35px;
                             width: 35px;border-radius: 50%;"
                 src={{element.profilePicture}} />
          </mat-cell>

          <mat-cell *ngIf="hasimageDialog">
            <img (click)="openDialog(element.contractImage) "
                 style="margin-bottom: 10px;width: 40px;
                             height: 50px;"
                 src="assets/images/viewImageICon.svg" />

          </mat-cell>
          <mat-cell style="width: 70px;"
                    *ngIf="tableData == 'expand'">
            <!-- <mat-icon (click)="expandedElement = expandedElement === element.id ? null : element.id"
                        style="width: 12px; color: #A5AEB6;" class="cp">
                        {{ expandedElement === element.id ? 'expand_less' : 'expand_more' }}
              </mat-icon> -->
            <button *ngIf="!element.isSingle"
                    mat-icon-button
                    aria-label="expand row"
                    (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()">
              <!-- <mat-icon *ngIf="expandedElement !== element">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="expandedElement === element">keyboard_arrow_up</mat-icon> -->
              <img width="30"
                   *ngIf="expandedElement === element"
                   src="assets/images/sdn/expand_arrow_down.png"
                   alt="">
              <img width="30"
                   *ngIf="expandedElement !== element"
                   src="assets/images/sdn/expand_arrow_up.png"
                   alt="">
            </button>
          </mat-cell>
          <mat-cell *ngIf="hasPreCircle"
                    style="justify-content: left !important;">
            <span [ngStyle]="{'background-color': element?.backColor,
                        'border-color': element?.borderColor}"
                  class="topbarCalender"></span>
            <span>{{element[tableData]}}</span>

          </mat-cell>
          <mat-cell style="width: 150px;"
                    *ngIf="showActions">
            <ng-container *ngIf="!props.onlyDelete && !props.hasDownload && !props.hasTickIcon">
              <button mat-button
                      style="border: 1px solid #D5D5D5; margin-right: 10px;"
                      [matMenuTriggerFor]="menu"
                      [disableRipple]="true">More
                <mat-icon style="width: 12px; color: #A5AEB6;">expand_more</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <ng-container *ngFor="let item of props?.ActionButtons">
                  <button *ngIf="getCondition(item,element)"
                          (click)="buttonClicked(element,item)"
                          mat-menu-item
                          [disabled]="!item.visibility">{{item.buttonLabel}}</button>
                </ng-container>

              </mat-menu>
            </ng-container>

            <div style="width: 50px;"
                 *ngIf="props.onlyDelete || props.hasDownload">
              <mat-icon *ngIf="props.onlyDelete"
                        (click)="deleteRow(element,tableData)"
                        style="width: 12px;position: relative;color: red">delete</mat-icon>

              <mat-icon *ngIf="props.hasDownload"
                        (click)="downloadAction(element,tableData)"
                        style="width: 12px;position: relative;color: blue;margin-left: 20px;">save_alt</mat-icon>
            </div>

            <!-- </ng-container> -->

            <ng-container *ngIf="hasSwitch">
              <label class="switch ">
                <input type="checkbox"
                       (change)="statusChanged(element)"
                       [(ngModel)]="element.status">
                <span class="slider round"></span>
              </label>
            </ng-container>
          </mat-cell>
        </td>
      </ng-container>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell
          *matCellDef="let element"
          [attr.colspan]="100">
        <div fxLayout="row wrap"
             class="example-element-detail"
             style="width: 100%; font-weight: bold;"
             [@detailExpand]="element == expandedElement ? 'collapsed' : 'expanded'">
          <div class="example-element-description"
               fxFlex="100">

            <table style="width: 100%;"
                   mat-table
                   [dataSource]="getDataSource(element[nestedDataKey])"
                   class="mat-elevation-z8 custom-table-striped">

              <!-- Columns & Data -->
              <ng-container [matColumnDef]="nestedtableData"
                            *ngFor="let nestedtableData of objectKeys(columnHeader)">
                <th mat-header-cell
                    *matHeaderCellDef> {{columnHeader[nestedtableData]}} </th>
                <td *matCellDef="let element">
                  <mat-cell [ngStyle]="{'width': getCellWidth(nestedtableData)}"
                            *ngIf="columnHeader[nestedtableData] != 'Actions'">
                    <span>
                      <span *ngIf="nestedtableData != 'discrepancy' && nestedtableData != 'note'">
                        {{element[nestedtableData]}}
                      </span>

                      <span *ngIf="element.sessionTime && nestedtableData == 'session'"
                            style="font-size: 12px;"> <br>{{element.sessionTime}}</span>

                      <span *ngIf="nestedtableData == 'discrepancy' && element.discrepancy == 'Discarded'"
                            style="position: relative;"
                            matTooltipClass="custom-tooltip"
                            [matTooltip]="element.discrepancyNote">
                        {{element[nestedtableData]}}
                      </span>
                      <span *ngIf="nestedtableData == 'discrepancy' && element.discrepancy != 'Discarded'">
                        {{element[nestedtableData]}}
                      </span>

                      <span *ngIf="nestedtableData == 'note' && element.longNote">
                        <span style="position: relative;"
                              matTooltipClass="custom-tooltip"
                              [matTooltip]="element.showNote">
                          {{element[nestedtableData]}}
                        </span>
                      </span>
                      <span *ngIf="nestedtableData == 'note' && !element.longNote">
                        {{element[nestedtableData]}}
                      </span>
                    </span>
                  </mat-cell>
                  <mat-cell [ngStyle]="{'width': getCellWidth(nestedtableData)}"
                            class="cp"
                            *ngIf="columnHeader[nestedtableData] == 'Actions'">

                    <!-- ------------*********----------- action buttons for expanded rows ------------*********----------- -->
                    <button mat-button
                            style="border: 1px solid #D5D5D5; margin-right: 10px;"
                            [matMenuTriggerFor]="menu"
                            [disableRipple]="true">More
                      <mat-icon style="width: 12px; color: #A5AEB6;">expand_more</mat-icon>
                    </button>

                    <mat-menu #menu="matMenu">
                      <ng-container *ngFor="let item of props?.ActionButtons">
                        <button *ngIf="getCondition(item,element)"
                                (click)="buttonClicked(element,item)"
                                mat-menu-item
                                [disabled]="!item.visibility">{{item.buttonLabel}}</button>
                      </ng-container>

                    </mat-menu>
                    <!-- <span style="color: #00AFBB"
                          (click)="openViewBreaksDialog(element)">View Breaks</span> -->
                    <!-- <span style="color: #00AFBB"></span> -->
                  </mat-cell>

                </td>
              </ng-container>

              <!-- <tr mat-header-row
                          *matHeaderRowDef="objectKeys(nestedColumns)" ></tr> -->
              <tr mat-row
                  *matRowDef="let element; columns: objectKeys(columnHeader);"
                  class="example-element-row"
                  [class.example-expanded-row]="expandedElement === element"
                  [ngStyle]="{'background': element['highlight']}">

            </table>

          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="objectKeys(columnHeader); sticky: true"></tr>
    <tr mat-row
        *matRowDef="let element; columns: objectKeys(columnHeader);"
        class="example-element-row"
        [class.example-expanded-row]="expandedElement === element"
        [ngStyle]="{'background': element['highlight']}">
      <!-- {{'background': element['highlight'] == true ? '[ color ]': ''}"}} -->
    </tr>
    <!-- <ng-container *ngIf="expandPanel"> -->
    <ng-container *ngIf="isExpandable">
      <tr mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"></tr>
    </ng-container>

    <!-- </ng-container> -->
    <!-- </mat-row> -->
  </table>
</div>

<!-- <mat-paginator #paginator
               [length]="dataSource?.data.length"
               [pageIndex]="0"
               [pageSize]="50"
               [pageSizeOptions]="[25, 50, 100, 250]">
</mat-paginator> -->
<div fxLayout="row"
     fxLayoutAlign="space-between center"
     style="padding-left: 10px; padding-right: 10px;">
  <div fxFlex="25">
    <p *ngIf="props?.pagination?.count > 0"
       class="text-small"
       style="color: #687784; margin-top: 38px">
      <!-- Total Count :
      <span *ngIf="props?.pagination?.page < perPage">{{props?.pagination?.count}}</span>
      <span
            *ngIf="props?.pagination?.page >= perPage">{{perPage*props?.pagination?.page}}</span>/{{props?.pagination?.count}} -->
      {{getPaginationText()}}
    </p>
  </div>
  <div fxFlex="75">
    <app-pagination *ngIf="props?.pagination?.count > 0"
                    (setPage)="setPage($event)"
                    perPage="10"
                    [totalPages]="props?.pagination?.pages"
                    [currentPage]="props?.pagination?.page"></app-pagination>
  </div>
</div>
